import React from 'react'

import { Container, Transition } from 'semantic-ui-react'

export const TransitionContainer = ({className, children}) => (
    <Container className={className}>
        <Transition 
        animation='fade'
        reactKey={className}
        transitionOnMount={true}
        visible={true}
        duration={500}
        >
            {children}
        </Transition>
    </Container>
)